export const FACEBOOK_PROFILE = "1";
export const FACEBOOK_PAGE = "2";
export const FACEBOOK_GROUP = "3";

export const TWITTER_PROFILE = "5";

export const GOOGLE_PROFILE = "8";
export const GOOGLE_PAGE = "9";
export const GOOGLE_GMB = "10";

export const LINKEDIN_PROFILE = "11";
export const LINKEDIN_GROUP = "12";
export const LINKEDIN_COMPANY = "13";

export const VKONTAKTE_PROFILE = "21";
export const VKONTAKTE_PAGE = "22";
export const VKONTAKTE_GROUP = "23";
export const VKONTAKTE_EVENT = "24";

export const INSTAGRAM_PROFILE = "30";
export const INSTAGRAM_BUSINESS = "31";

export const PINTEREST_PROFILE = "35";
export const PINTEREST_BOARD = "36";

export const TIKTOK_PROFILE = "40";

export const YOUTUBE_CHANNEL = "45";

export const ALL_FACEBOOK = [FACEBOOK_PROFILE, FACEBOOK_PAGE, FACEBOOK_GROUP];
export const ALL_TWITTER = [TWITTER_PROFILE];
export const ALL_GOOGLE = [GOOGLE_PROFILE, GOOGLE_PAGE, GOOGLE_GMB];
export const ALL_YOUTUBE = [YOUTUBE_CHANNEL];
export const ALL_LINKEDIN = [
  LINKEDIN_PROFILE,
  LINKEDIN_GROUP,
  LINKEDIN_COMPANY,
];
export const ALL_VKONTAKTE = [
  VKONTAKTE_PROFILE,
  VKONTAKTE_PAGE,
  VKONTAKTE_GROUP,
  VKONTAKTE_EVENT,
];
export const ALL_INSTAGRAM = [INSTAGRAM_PROFILE, INSTAGRAM_BUSINESS];
export const ALL_PINTEREST = [PINTEREST_PROFILE, PINTEREST_BOARD];
export const ALL_TIKTOK = [TIKTOK_PROFILE];

export const ALL_TYPES = [
  ...ALL_FACEBOOK,
  ...ALL_INSTAGRAM,
  ...ALL_TWITTER,
  ...ALL_GOOGLE,
  ...ALL_YOUTUBE,
  ...ALL_LINKEDIN,
  ...ALL_VKONTAKTE,
  ...ALL_PINTEREST,
  ...ALL_TIKTOK,
];
